import { formatDigit } from "./format.util";

const OrderHistory = ({ orders }) => {
  return (
    <div className="ne_box h_100 br_0">
      <div className="market-trade">
        <div className="tradehistory tradehistory-new">
          <div className="item-con tradeHistory-base" id="tradeHistory">
            <h6 className="h6_head">Recent Trades</h6>
            <div className="scrollStyle ng-scope">
              <table className="table mb-0">
                <thead>
                  <tr>
                    <th>Price</th>
                    <th>Amount</th>
                    <th>Pair</th>
                    <th>Date & Time</th>
                  </tr>
                </thead>
                <tbody>
                  {orders.length === 0 ? (
                    <tr>
                      <td colSpan={4} style={{ textAlign: "center" }}>
                        No data available
                      </td>
                    </tr>
                  ) : (
                    orders.map((singleData, i) => (
                      <tr className="ng-scope" key={i}>
                        <td className={`f-left ng-binding `} style={{
                          color: singleData.flag, // Inline style for green or red
                        }}>
                          {formatDigit(singleData.price)}
                        </td>
                        <td className="f-left ng-binding">
                          {formatDigit(singleData.amount)}
                        </td>
                        <td className="f-left ng-binding">
                          {singleData.pair}
                        </td>
                        <td className="f-left ng-binding">{singleData.time}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { OrderHistory };
